import { createPinia } from 'pinia'
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import 'bootstrap';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser, faCopy } from '@fortawesome/free-regular-svg-icons'
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
library.add(faUser, faCopy, faTriangleExclamation)


import { msalPlugin } from './plugins/msalPlugin'
import { msalInstance } from "./services/auth";

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.use(msalPlugin, msalInstance);

app.mount('#app')


import './assets/css/main.css';
import 'bootstrap/dist/css/bootstrap.css';